import Vue from 'vue'
import Vuex from 'vuex'
import { AI_DIRECT_CHAT_ENABLED } from '../assets/feature_flags.js'

Vue.use(Vuex)

const state = {
  beforeEatchInitialized: false, // beforeEach和App.vue的mounted是同时执行，不符合使用预期，使用这个标志位来强制让mounted在beforeEach完全执行后再执行
  configFetched: false,
  wwRegistered: false, // ww没有wx.ready函数，得自己上手
  showManagerMsgPopover: false, //控制客服消息图片的popover是否展示
  needLogin: false,
  alreadyLogin: false,
  user: {},
  floatBtn: {
    show: false,
    textLine1: '',
    textLine2: '',
    targetUrl: '',
    needReload: false,
    platformModeTextLine: '',
    platformModeTargetUrl: '',
    showPopover: false,
    popoverText: ''
  },
  groupChatFloatBtn: {
    showPopover: false,
    popoverText: '',
  },
  chatBoxRef: null,
  showLoading: false,
  // 全局 WebSocket 状态
  wsConnected: false,
  wsRegistered: false,
  wsUserId: null,
  hasUnreadChatMsg: false,
  hasUnreadMatch: false,
  hasUnreadChannelMsg: false,
  currentChatWithUserId: null,
  hasUnreadInteraction: false,
  hasUnreadMsg: false,
  unreadChatCount: 0, // 私聊未读消息总数（messages tab 数字 badge，long 按数字归一化存储）
  unreadInteractionCount: 0, // 未读互动通知条数（计入 messages tab 数字 badge）
  unreadMatchCount: 0, // 未读匹配总数（matches tab 数字 badge）
  contactDnd: {}, // 联系人免打扰映射 targetUserId -> 0/1（WS 收消息时快速判断是否点亮红点）
  showOnboarding: false,
  showAiChatPopup: false // 全局独立 AI 对话弹窗开关（见 setShowAiChatPopup）
}

const mutations = {
  setHasUnreadChatMsg(state, value) {
    state.hasUnreadChatMsg = value
  },
  setHasUnreadMatch(state, value) {
    state.hasUnreadMatch = value
  },
  setHasUnreadChannelMsg(state, value) {
    state.hasUnreadChannelMsg = value
  },
  setHasUnreadInteraction(state, value) {
    state.hasUnreadInteraction = value
  },
  setHasUnreadMsg(state, value) {
    state.hasUnreadMsg = value
  },
  setUnreadChatCount(state, value) {
    state.unreadChatCount = parseInt(value, 10) || 0
  },
  setUnreadInteractionCount(state, value) {
    state.unreadInteractionCount = parseInt(value, 10) || 0
  },
  setUnreadMatchCount(state, value) {
    state.unreadMatchCount = parseInt(value, 10) || 0
  },
  // 用联系人列表批量刷新免打扰映射（含 dnd 字段），或用单条 {userId, dnd} 更新
  setContactsDnd(state, contacts) {
    if (Array.isArray(contacts)) {
      contacts.forEach(contact => {
        state.contactDnd[contact.targetUserId] = parseInt(contact.dnd, 10) === 1
      })
    } else if (contacts && contacts.userId) {
      state.contactDnd[contacts.userId] = contacts.dnd == 1
    }
  },
  setShowOnboarding(state, value) {
    state.showOnboarding = value
  },
  // 全局独立 AI 对话弹窗（首页「发布消息」/底部「+」/Onboarding/草稿续写的统一入口，
  // 复用 ChatBox，替代原 /ai 独立页，与群内 AI 聊天弹窗同一交互形态）
  setShowAiChatPopup(state, value) {
    // AI 直聊入口开关关闭时，兜底忽略所有「打开」commit（关闭弹窗不受影响），
    // 覆盖 Onboarding/底部「+」/侧栏「发布」/草稿续写等全部开启点及未来新增入口
    if (value && !AI_DIRECT_CHAT_ENABLED) return
    state.showAiChatPopup = value
  },
  setCurrentChatWithUserId(state, value) {
    state.currentChatWithUserId = value
  }
}

const chatContracts = []
const chatMsgs = new Set()

export default new Vuex.Store({
  state,
  mutations,
  chatContracts,
  chatMsgs
})


// WEBPACK FOOTER //
// ./src/store/index.js